"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const CardName_1 = require("@/common/cards/CardName");
const PlayerResource_vue_1 = __importDefault(require("@/client/components/overview/PlayerResource.vue"));
const Resource_1 = require("@/common/Resource");
exports.default = (0, vue_1.defineComponent)({
    name: 'PlayerResources',
    props: {
        player: {
            type: Object,
            required: true,
        },
    },
    computed: {
        Resource() {
            return Resource_1.Resource;
        },
        canUseHeatAsMegaCredits() {
            return this.player.tableau.some((card) => card.name === CardName_1.CardName.HELION);
        },
    },
    components: {
        'player-resource': PlayerResource_vue_1.default,
    },
});
